//External
import { useEffect } from "react";

let activeLocks = 0;
let lockedScrollY = 0;
let restoreStyle = null;

/*******************
@purpose : freeze the page behind an open sheet the way WebKit actually
           requires - overflow: hidden on <body> alone still lets iOS scroll
           and rubber-band the page under a fixed overlay
@Author : INIC
******************/
const lockBody = () => {
  activeLocks += 1;
  if (activeLocks > 1) return;

  const { body } = document;
  lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
  restoreStyle = {
    position: body.style.position,
    top: body.style.top,
    left: body.style.left,
    right: body.style.right,
    width: body.style.width,
  };

  body.style.position = "fixed";
  body.style.top = `-${lockedScrollY}px`;
  body.style.left = "0";
  body.style.right = "0";
  body.style.width = "100%";
};

/*******************
@purpose : restore the inline styles and the scroll position taken at lock
           time. Blurs first so a sheet dismissed while its keyboard is still
           up doesn't have iOS re-scrolling the page after the restore
@Author : INIC
******************/
const unlockBody = () => {
  activeLocks = Math.max(activeLocks - 1, 0);
  if (activeLocks > 0 || !restoreStyle) return;

  const { body } = document;
  if (document.activeElement && typeof document.activeElement.blur === "function") {
    document.activeElement.blur();
  }

  body.style.position = restoreStyle.position;
  body.style.top = restoreStyle.top;
  body.style.left = restoreStyle.left;
  body.style.right = restoreStyle.right;
  body.style.width = restoreStyle.width;
  restoreStyle = null;

  window.scrollTo(0, lockedScrollY);
};

/*******************
@Purpose : Shared background-scroll lock for the mobile bottom sheets
           (LocationPopover's mobileSheet, FiltersDialog). Reference-counted
           so overlapping sheets can't restore each other's scroll position,
           and unlocks on unmount as well as on close.
@Parameter : {isActive}
@Author : INIC
******************/
const useSheetScrollLock = (isActive) => {
  useEffect(() => {
    if (!isActive || typeof document === "undefined") return undefined;

    lockBody();
    return unlockBody;
  }, [isActive]);
};

export default useSheetScrollLock;
